<div class="itineraryBox_wrapper">

  <div class="accomodation_wrapper">
    <div #car_hire></div>   
  </div>
</div>